import { render, staticRenderFns } from "./CategoryManage.vue?vue&type=template&id=27d9ae8a&scoped=true&"
import script from "./CategoryManage.vue?vue&type=script&lang=js&"
export * from "./CategoryManage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryManage.vue?vue&type=style&index=0&id=27d9ae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d9ae8a",
  null
  
)

export default component.exports